import type { ValueOf } from '../../types';

export const Template = {
  None: 'None',
  Straight: 'Straight',
  Head: 'Head',
  HeadFlipped: 'HeadFlipped',
  Line: 'Line',
  Skirt: 'Skirt',
  Skirt2: 'Skirt2',
  Skirt3: 'Skirt3',
} as const;

export type Template = ValueOf<typeof Template>;

export enum BreakOverlayType {
  BOTTOM = 'bottom',
  BOTTOM_HALF = 'bottomHalf',
  NONE = 'none',
  TOP = 'top',
  TOP_HALF = 'topHalf',
  TOP_HALF_AND_BOTTOM_HALF = 'topAndBottomHalfs',
}
